import { render, staticRenderFns } from "./companylist.vue?vue&type=template&id=7c7de50c&scoped=true&"
import script from "./companylist.vue?vue&type=script&lang=js&"
export * from "./companylist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7de50c",
  null
  
)

export default component.exports